import { reportError } from "@/utils/reportError";
import * as Linking from "expo-linking";
import { Alert } from "react-native";

/**
 * Opens an external URL without crashing.
 *
 * `Linking.openURL` rejects when the OS finds no app to handle the scheme
 * (e.g. a `mailto:` link on a device with no mail client, or a missing
 * browser). Left unhandled, that rejection surfaced in Sentry as a crash
 * ("No Activity found to handle Intent"). We catch it and, when provided,
 * show a friendly fallback Alert so the user still gets the info (e.g. the
 * email address to copy manually).
 */
export async function openUrlSafely(
  url: string,
  fallback?: { title: string; message: string }
): Promise<void> {
  try {
    await Linking.openURL(url);
  } catch (error) {
    reportError(error);
    if (fallback) {
      Alert.alert(fallback.title, fallback.message);
    }
  }
}
